/* eslint-disable @angular-eslint/component-selector */
import { registerLocaleData } from '@angular/common'
import localeDE from '@angular/common/locales/de-CH'
import localeEN from '@angular/common/locales/en-CH'
import localeFR from '@angular/common/locales/fr-CH'
import { ChangeDetectionStrategy, Component, inject, ViewEncapsulation } from '@angular/core'

import { CLIENT_CONFIG } from 'app/core/client-config/client-config.token'
import { PreconnectLinkService } from 'app/core/preconnect-link.service'
import { FlyingFocusComponent } from 'app/shared/flying-focus/flying-focus.component'
import { RouterOutletDirective } from 'app/shared/router-outlet.directive'

import { JSON_LD_ORGANIZATION } from './core/meta/json-ld.token'
import { MetaService } from './core/meta/meta.service'

// fixme this registering of Locales seems odd in angular - is there another way
registerLocaleData(localeDE)
registerLocaleData(localeFR)
registerLocaleData(localeEN)

@Component({
  selector: 'app-root',
  template: '<ng-template routerOutlet/><pai-flying-focus/>',
  imports: [RouterOutletDirective, FlyingFocusComponent],
  styleUrls: ['./app.component.scss', '../styles/critical.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent {
  constructor() {
    const clientConfig = inject(CLIENT_CONFIG)
    inject(MetaService).setDefaultJsonLd([inject(JSON_LD_ORGANIZATION)])
    inject(PreconnectLinkService).add(clientConfig.assetsOrigin, clientConfig.cmsOrigin)
  }
}
